import { Skeleton, Stack } from '@mui/material'
import { FC } from 'react'
import { SkeletonText } from 'utoniq-ui'

export const ItemDescriptionSkeleton: FC = () => (
  <Stack spacing={4}>
    <Stack direction="row" spacing={7} alignItems="center" sx={{ px: 5 }}>
      <Skeleton variant="rectangular" width={60} height={90} />
      <Stack flex={1} spacing={2}>
        <SkeletonText variant="medium" width="100%" />
        <Stack direction="row" spacing={2} alignItems="center">
          <Skeleton variant="circular" width={20} height={20} />
          <SkeletonText variant="small" width="50%" />
        </Stack>
      </Stack>
    </Stack>
    <Stack spacing={2}>
      <SkeletonText variant="medium" width="50%" />
      <Stack>
        <SkeletonText variant="small" numberOfLine={3} lastWidth="100%" />
      </Stack>
    </Stack>
  </Stack>
)
